"use strict";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

Shopify.theme.jsAjaxCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(
      this,
      Shopify.theme.getSectionData($section)
    );

    if (isScreenSizeLarge() || this.cart_action == "drawer") {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == "drawer") {
      this.ajaxCartDrawer = $("[data-ajax-cart-drawer]");
      $(document).on("click", "[data-ajax-cart-trigger]", function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();
        return false;
      });
    } else if (this.cart_action == "mini_cart") {
      this.showMiniCartOnHover();
    }

    $(document).on("click", ".ajax-submit", function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest("form");
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    $(document).on("click", "[data-ajax-cart-delete]", function (e) {
      e.preventDefault();
      var lineID = $(this).parents("[data-line-item]").data("line-item");
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });
    $(document).on("click", "[data-ajax-cart-close]", function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();
      return false;
    });

    // Upsell cart
    $("body").on(
      "click",
      ".upsell-item .nosto-sizes .nosto-size",
      function (e) {
        $(this).parent(".nosto-sizes").removeClass("expanded");
        $(".nosto-sizes").removeClass("expanded");
        var variant_id = $(this).attr("value");
        Shopify.theme.jsAjaxCart.addToCartUpsell(variant_id, 1);
      }
    );
    $("body").on(
      "click",
      ".upsell-item .nosto-quick-add:not(.quick-add-variants)",
      function (e) {
        var variant_id = $(this).attr("data-variant-id");
        Shopify.theme.jsAjaxCart.addToCartUpsell(variant_id, 1);
      }
    );
    $("body").on("click", ".nosto-quick-add", function (e) {
      var $sizes = $(this).parent().find(".nosto-sizes");
      var $arrowUp = $(this).find(".arrow-up");
      var $arrowDown = $(this).find(".arrow-down");

      // Toggle the expanded class for sizes
      $sizes.toggleClass("expanded");

      // Toggle the arrow direction
      $arrowUp.toggleClass("hidden");
      $arrowDown.toggleClass("hidden");

      // Hide other expanded sizes and arrows
      $(".nosto-quick-add")
        .not(this)
        .each(function () {
          $(this).parent().find(".nosto-sizes").removeClass("expanded");
          $(this).find(".arrow-up").removeClass("hidden");
          $(this).find(".arrow-down").addClass("hidden");
        });
    });
  },
  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $("[data-ajax-cart-trigger]");
    $el.hover(
      function () {
        if (
          Shopify.theme_settings.header_layout == "centered" &&
          $(".header-sticky-wrapper").hasClass("is-sticky")
        ) {
          $(".header-sticky-wrapper [data-ajax-cart-trigger]").addClass(
            "show-mini-cart"
          );
        } else {
          $el.addClass("show-mini-cart");
        }
      },
      function () {
        $el.removeClass("show-mini-cart");
      }
    );
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != "mini_cart") return false;
    var $el = $("[data-ajax-cart-close]").parents("[data-ajax-cart-trigger]");
    $el.removeClass("show-mini-cart");
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $(".mobile-header [data-ajax-cart-trigger]"); // Removes url to the cart page so user is not redirected

    $el.attr("href", "#");
    $el.off("click").on("click", function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest("[data-ajax-cart-mini_cart]")) {
        return;
      } // Loads content into ajaxCart container for mobile header

      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      $el.toggleClass("show-mini-cart"); // Calculate height of mini cart

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt($(".mobile-header").height());

      if (
        typeof Shopify.theme.jsAnnouncementBar !== "undefined" &&
        Shopify.theme.jsAnnouncementBar.enable_sticky
      ) {
        announcementHeight =
          Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      $(".mobile-header .theme-ajax-cart").css({
        height: "calc(100vh - ".concat(
          mobileHeaderHeight + announcementHeight,
          "px)"
        ),
      });
    });
  },

  cartUpSell: function cartUpSell() {
    if ($(".header-cart .upsell-slider .upsell-item").length > 6) {
      $(".upsell-slider .upsell-item:nth-child(n + 7)").remove();
    }
    if ($(".header-cart .upsell-slider .upsell-item").length < 0) {
      $(".ajax-cart__upsell").hide();
    }
    if ($(window).width() <= 600) {
      if ($(".header-cart .upsell-slider .upsell-item").length > 2) {
        $(".upsell-slider .upsell-item:nth-child(n + 3)").remove();
      }
      if ($(".header-cart .upsell-slider .upsell-item").length < 1) {
        $(".ajax-cart__upsell").hide();
      }
    }

    if ($(".upsell-slider").length > 0) {
      $(".upsell-slider").owlCarousel({
        loop: false,
        mouseDrag: true,
        touchDrag: false,
        pullDrag: false,
        freeDrag: false,
        margin: 0,
        items: 3,
        dots: false,
        nav: true,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
        ],
        responsiveClass: true,
        responsive: {
          0: {
            items: 2,
            slideBy: 2,
          },
          600: {
            items: 3,
            slideBy: 3,
          },
          1000: {
            items: 3,
            slideBy: 3,
          },
        },
      });
    }
  },

  showDrawer: function showDrawer() {
    if (this.cart_action != "drawer") return false;
    this.ajaxCartDrawer.addClass("is-visible");
    $(".ajax-cart__overlay").addClass("is-visible");
  },
  hideDrawer: function hideDrawer() {
    if (this.cart_action != "drawer") return false;
    this.ajaxCartDrawer.removeClass("is-visible");
    $(".ajax-cart__overlay").removeClass("is-visible");
  },
  removeFromCart: function removeFromCart(lineID, callback) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=0&line=" + lineID,
      dataType: "json",
      success: function success(cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval("(" + XMLHttpRequest.responseText + ")");
        response = response.description;
      },
    });
  },
  initializeAjaxCart: function initializeAjaxCart() {
    Shopify.theme.asyncView
      .load(
        Shopify.routes.cart_url, // template name
        "ajax" // view name (suffix)
      )
      .done(function (_ref) {
        var html = _ref.html,
          options = _ref.options;
        $("[data-ajax-cart-content]").html(html.content); // Converting the currencies

        if (Currency.show_multiple_currencies) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }
        Shopify.theme.jsAjaxCart.cartUpSell();
      })
      .fail(function () {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
    this.toggleMiniCart();
    Shopify.theme.asyncView
      .load(
        Shopify.routes.cart_url, // template name
        "ajax" // view name (suffix)
      )
      .done(function (_ref2) {
        var html = _ref2.html,
          options = _ref2.options;
        $(".mobile-header [data-ajax-cart-content]").html(html.content);

        Shopify.theme.jsAjaxCart.cartUpSell();
      })
      .fail(function () {
        // some error handling
      });
  },
  addToCartUpsell: function addToCartUpsell(variant_id, qty) {
    var data = {
      id: variant_id,
      quantity: qty,
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
    });
  },
  addToCart: function addToCart($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find(".button--add-to-cart");
    $.ajax({
      url: "/cart/add.js",
      dataType: "json",
      cache: false,
      type: "post",
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn.attr("disabled", "disabled").addClass("disabled");
        $addToCartBtn
          .find("span")
          .removeClass("fadeInDown")
          .addClass("animated zoomOut");
      },
      success: function success(product) {
        var $el = $("[data-ajax-cart-trigger]");
        $addToCartBtn.find(".checkmark").addClass("checkmark-active");

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $(".mobile-header [data-ajax-cart-trigger]");
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $("[data-ajax-cart-trigger]");
          }

          $el.addClass("show-mini-cart");
          $addToCartBtn.find("span").removeClass("fadeInDown");
        }

        window.setTimeout(function () {
          $addToCartBtn.removeAttr("disabled").removeClass("disabled");
          $addToCartBtn.find(".checkmark").removeClass("checkmark-active");
          $addToCartBtn
            .find(".text, .icon")
            .removeClass("zoomOut")
            .addClass("fadeInDown");
          $addToCartBtn.on(
            "webkitAnimationEnd oanimationend msAnimationEnd animationend",
            addedToCart
          );
        }, 1000);
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        if (Shopify.theme.jsCart) {
          var _$$ajax;

          $.ajax(
            ((_$$ajax = {
              dataType: "json",
              async: false,
              cache: false,
            }),
            _defineProperty(_$$ajax, "dataType", "html"),
            _defineProperty(_$$ajax, "url", "/cart"),
            _defineProperty(_$$ajax, "success", function success(html) {
              var cartForm = $(html).find(".cart__form");
              $(".cart__form").replaceWith(cartForm);
            }),
            _$$ajax)
          );
        }
      },
      error: function error(XMLHttpRequest) {
        var response = eval("(" + XMLHttpRequest.responseText + ")");
        response = response.description;
        var cartWarning =
          '<p class="cart-warning__message animated bounceIn">'.concat(
            response.replace("All 1 ", "All "),
            "</p>"
          );
        $(".warning").remove();
        $addToCartForm.find(".cart-warning").html(cartWarning);
        $addToCartBtn.removeAttr("disabled").removeClass("disabled");
        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");
        $addToCartBtn
          .find(".text")
          .text(Shopify.translation.addToCart)
          .removeClass("zoomOut")
          .addClass("zoomIn");
      },
    });
  },
  updateView: function updateView() {
    Shopify.theme.asyncView
      .load(
        Shopify.routes.cart_url, // template name
        "ajax" // view name (suffix)
      )
      .done(function (_ref3) {
        var html = _ref3.html,
          options = _ref3.options;

        if (options.item_count > 0) {
          var itemList = $(html.content).find(".ajax-cart__list");
          var cartDetails = $(html.content).find(".ajax-cart__details-wrapper");
          $(".ajax-cart__list").replaceWith(itemList);
          $(".ajax-cart__details-wrapper").replaceWith(cartDetails);
          $(".ajax-cart__empty-cart-message").addClass("is-hidden");
          $(".ajax-cart__form").removeClass("is-hidden");
          $("[data-ajax-cart-trigger]").addClass("has-cart-count");
          $('[data-bind="itemCount"]').text(options.item_count);
        } else {
          $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
          $(".ajax-cart__form").addClass("is-hidden");
          $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
          $('[data-bind="itemCount"]').text("0");
        }

        $(".shipping-progress").replaceWith(
          $(html.content).find(".shipping-progress")
        );

        if (Currency.show_multiple_currencies) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }
        $(".discount-bar").replaceWith($(html.content).find(".discount-bar"));

        Shopify.theme.jsAjaxCart.cartUpSell();
      })
      .fail(function () {
        // some error handling
      });
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $(".ajax-submit").off();
    $("[data-ajax-cart-delete]").off();
  },
};
